var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.industry-checker .main-content {\n  background: #fff;\n  padding: 16px 4px 16px 16px;\n}\n.industry-checker .item-class {\n  border: 1px solid #ececec;\n  padding: 5px 15px;\n  /*margin-right: 4px;*/\n  margin-bottom: 4px;\n  width: 30.3%;\n  text-align: center;\n  margin-right: 3%;\n}\n.industry-checker .item-selected {\n  /*border: 1px solid #4c83bd;*/\n  background: #f8fbff url(" + escape(require("../assets/uu60.png")) + ") no-repeat right bottom;\n  border-color: #52c1f5;\n}\n.industry-checker .item-disable {\n  background: #ccc;\n  color: #fff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e23d5542","scoped":false,"hasInlineConfig":false}!./~/vux-loader/src/after-less-loader.js!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vux-loader/src/style-loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/plugin/industry-checker.vue
// module id = 283
// module chunks = 1